import { NavListItem, NavListItemProps } from '.';

export const NavListItemPrimary = (props: NavListItemProps) => {
  const { className } = props;
  return <NavListItem className={className || 'text-h-16'} {...props} />;
};
